import { useState } from "react";
import { Link } from "react-router-dom";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./CategoriesSlider.module.scss";

const CategoriesCard = ({ category }) => {
    return (
        <div className={styles.category_card}>
            <Link to={`/category/${category.slug}_${category.id}`}>
                <div>
                    <img src={category.image} alt={category.name} />
                </div>
                <h3>{category.name}</h3>
            </Link>
        </div>
    );
};

const CategoriesSlider = ({ categories }) => {
    const [, setSlider] = useState({});

    const sliderProps = {
        onInit: (ev) => {
            setSlider(ev);
        },
        modules: [Autoplay],
        loop: false,
        breakpoints: {
            310: {
                slidesPerView: 3.2,
                spaceBetween: 10,
            },
            480: {
                slidesPerView: 3.2,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 3.2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 6,
                spaceBetween: 15,
            },
        },
    };

    return (
        <div className={`${styles.categoriesSlider} container px-0`}>
            <div className={"see_more_title"}>
                <h2>Categories</h2>
            </div>

            <div className={styles.category_slider_item}>
                <div className={styles.category_main_slider}>
                    <Swiper {...sliderProps} style={{ overflow: "unset", width: "400px" }}>
                        {categories?.map((category, index) => {
                            return (
                                <SwiperSlide key={index} style={{ height: "unset !important" }}>
                                    <CategoriesCard category={category} />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default CategoriesSlider;
